import client from '../client';
import * as fileMutations from "../mutations/files";
import * as fileQueries from "../queries/files";



export function getFiles(success, error, fogId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { fogId: fogId },
        fetchPolicy: fetchPolicy,
        query: fileQueries.all,
    })
    .then(success)
    .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: fileQueries.get,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { file: data },
        mutation: fileMutations.add,
    }).then(success).catch(error);
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, file: data },
        mutation: fileMutations.edit,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/files.js